import { TDispatch } from '../type';
import { ISearchedTruckerProps, TSearchTruckers } from './searchTruckers.type';

export const SearchTruckersReducer = (state: TSearchTruckers, { type, payload }: TDispatch): TSearchTruckers => {
  switch (type) {
    case 'search_truckers_load':
      return {
        ...state,
        isFetchingSearch: true,
        isFetchedSearch: false,
        dataSearch: null,
        errorSearch: null,
      };
    case 'search_truckers_load_success':
      return {
        ...state,
        isFetchingSearch: false,
        isFetchedSearch: true,
        dataSearch: payload as ISearchedTruckerProps,
        errorSearch: null,
      };
    case 'search_truckers_load_error':
      return {
        ...state,
        isFetchingSearch: false,
        isFetchedSearch: true,
        dataSearch: null,
        errorSearch: payload as TSearchTruckers['errorSearch'],
      };
    case 'search_truckers_set_term':
      return {
        ...state,
        term: payload as TSearchTruckers['term'],
      };

    case 'search_truckers_clear':
      return {
        ...state,
        isFetchingSearch: false,
        isFetchedSearch: false,
        dataSearch: null,
        term: null,
        isSearchFieldOnFocus: false,
        errorSearch: null,
      };
    case 'search_field_focus_set':
      return {
        ...state,
        isSearchFieldOnFocus: true,
      };

    default:
      return state;
  }
};

SearchTruckersReducer.key = 'searchTruckers';
SearchTruckersReducer.initialState = {
  isFetchingSearch: false,
  isFetchedSearch: false,
  dataSearch: null,
  term: null,
  isSearchFieldOnFocus: false,
  errorSearch: null,
};

export default { SearchTruckersReducer };
